import React from 'react';

import { Row } from '~components/table-view-v3';

interface ComponentProps {
  row: Row;
}

const StatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const { status } = row || {};
  const { colour, name } = status || {};
  return (
    <div className="status-block-L" style={{ borderLeft: `6px solid #${colour}` }}>
      {name}
    </div>
  );
};

export default StatusBadge;
